import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { tracked } from '@glimmer/tracking';

import type { PopupData } from 'webapp-types';
import { PopupEvent } from 'webapp/enums/enums';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormRadiobuttonComponent from 'webapp/components/form/radiobutton';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class CustomQueryPopupPurgeComponent extends PopupInnerModalComponent<PopupData.CustomQuery.Purge> {
	@tracked purgeOption = 1;

	wasSaved = false;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.args.model.on(PopupEvent.CLOSING, this, () => {
			if (!this.wasSaved) {
				this.popupData.onSkip();
			}
		});
	}

	@action
	changePurgeOption(value: AnySimpleValue): void {
		this.purgeOption = value as number;
	}

	@action
	save(): void {
		this.popupData.onSave(!!this.purgeOption);
		this.wasSaved = true;
		this.close();
	}
	<template>
		<div class="title">
			<CommonUiIconComponent @name="DataInsert" @size="lg" />
			Would you like to clear the previously stored data?
		</div>
		<div class="content">
			<div class="choose-default">

				<p>
					<strong>
						By changing the built metric settings, new data will use different criteria
						than the data you already have stored.
					</strong>
					Because of this, we recommend purging any existing data stored for this metric.
				</p>

				<div class="radiobutton-default">
					<FormRadiobuttonComponent
						@name="purgeOption"
						@selected={{this.purgeOption}}
						@value={{1}}
						@label="Purge existing data stored"
						@onChange={{this.changePurgeOption}}
					/>
					<span class="lower-label">Recommended option</span>
				</div>

				<div class="radiobutton-default">
					<FormRadiobuttonComponent
						@name="purgeOption"
						@selected={{this.purgeOption}}
						@value={{0}}
						@label="Leave data stored and append new"
						@onChange={{this.changePurgeOption}}
					/>
				</div>

			</div>
			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						@text="Cancel"
						@theme="grey-empty"
						@noDelay={{true}}
						@onTrigger={{this.close}}
					/>
					<SubmitButtonComponent
						@text="Select"
						@extraClass="save"
						@onTrigger={{this.save}}
					/>
				</div>
			</div>

		</div>
	</template>
}
